var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"scroll-top-fade"}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"scroll-top-btn",attrs:{"fab":"","fixed":"","bottom":"","right":"","color":"primary","elevation":"6"},on:{"click":_vm.scrollToTop}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }